<template>
  <v-col class="mb-3" cols="7">
    <h3 class="ml-2 mb-3">商品画像</h3>
    <div class="px-2">
      <div class="p-productImageInput__wrap">
        <div class="p-productImageInput__text">画像ファイルをアップロードもしくは、画像URLを入力して「追加」ボタンを押してください。</div>
        <v-row>
          <v-col class="pb-0" cols="10">
            <v-file-input
              v-model="inputFiles"
              multiple
              :accept="acceptType"
              label="画像アップロード"
            />
          </v-col>
          <v-col class="text-center pb-0" cols="2" style="align-self: center">
            <v-btn dark color="indigo" class="mx-3" small @click="addFileImages">
              追加
            </v-btn>
          </v-col>

          <v-col cols="10">
            <v-text-field
              v-model="inputUrl"
              multiple
              :accept="acceptType"
              label="画像URLを入力する"
            />
          </v-col>
          <v-col class="text-center" cols="2" style="align-self: center">
            <v-btn dark color="indigo" class="mx-3" small @click="addUrlImages">
              追加
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <SortImages :value="productImages" @change="changeProductImages" />
    </div>
  </v-col>
</template>

<script>
import SortImages from './SortImages'

export default {
  name: 'ProductImageForm',
  components: { SortImages },
  model: {
    prop: 'productImages',
    event: 'update-images'
  },
  props: {
    productImages: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      inputFiles: [],
      inputUrl: '',
      acceptType: 'image/png, image/jpeg, image/bmp',
      loadingImage: false
    }
  },
  watch: {
    productImages () {
      this.loadProductImages()
    }
  },
  mounted () {
    this.loadProductImages()
  },
  methods: {
    loadProductImages () {
      if (this.loadingImage) { return }

      this.loadingImage = true
      this.productImages.map((val, index) => {
        if (val.previewUrl) return
        console.log(val)
        this.$set(
          this.productImages,
          index,
          this.formatImageObject(val, !!val.id)
        )
      })
      this.loadingImage = false
    },
    addFileImages () {
      if (this.inputFiles.length) {
        this.inputFiles.map((file) =>
          this.productImages.push(this.formatImageObject(file, false))
        )
        this.inputFiles = []
      }
    },
    addUrlImages () {
      if (this.inputUrl) {
        this.productImages.push(this.formatUrlImageObject(this.inputUrl, false))
        this.inputUrl = ''
      }
    },
    formatImageObject (file, uploaded) {
      return {
        ...file,
        file: file,
        imageType: 'file',
        uploaded: !!uploaded,
        deleted: !!file.deleted,
        previewUrl: uploaded ? file.imageUrl : this.fileUrl(file)
      }
    },
    formatUrlImageObject (url) {
      return {
        url: url,
        imageType: 'file',
        uploaded: false,
        deleted: false,
        previewUrl: url
      }
    },
    fileUrl (file) {
      return window.URL.createObjectURL(file)
    },
    changeProductImages (images) {
      this.$emit('update-images', images)
    }
  }
}
</script>

<style scoped>
.p-productImageInput__wrap {
  padding: 20px 10px 10px;
  border: 1px solid #BEBEBE;
  border-radius: 10px;
  margin-bottom: 30px;
}
.p-productImageInput__text {
  margin-left: 10px;
  font-size: 12px;
  color: #696969;
}
</style>
